<template>
  <swiper class="swiper main_banner" :options="mainBannerOption">
    <swiper-slide v-for="(item, idx) in mainBanner" :key="idx" class="swiper-slide">
      <a :href="item.landingUrl" class="swiperBox">
        <img :src="item.imageUrl" alt="배너 이미지" />
      </a>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import http from '@/api/shopBy';
import 'swiper/css/swiper.css'
import boardCont from '@/common/board'

// apis호출 메소드 모음.
const apis = {
  mainBanner: (bannerSesencode) => http.get(`/display/banners/${bannerSesencode}`)
}
const MAINBANNER = boardCont.mainSlideCode; //메인배너 섹션코드

export default {
  name: 'MainSlider-3c468f',
  components: {
    Swiper,
    SwiperSlide,
  },
  data(){
    return {
      mainBanner: [],
      mainBannerOption: {
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
      },
    }
  },
  mounted() {
    this.init()
  },
  methods:{
    async init(){
      const bannerData = await apis.mainBanner(MAINBANNER);
      bannerData.data[0].accounts.forEach(el=> {
        this.mainBanner.push(el.banners[0]);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/constants/colors.scss';
@import '@/assets/styles/constants/typography.scss';
.swiper-pagination {
  bottom: 20px;
  background-color: $gray-c4;
  padding: 0px 10px 2px 10px;
  letter-spacing: -2px;
}

</style>